'use client';

import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import GridLayout, { GridItem } from '@/src/layouts/GridLayout';
import { useScroll } from '@/src/components/global/ScrollContext';
import { cx } from '@/src/styles/stylebook';
// 단순 슬러그 처리: id로 안전하게 사용
const toId = text => text.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-가-힣]/g, '-').replace(/-+/g, '-');
export default function FaqClient({
  groupedFaqs
}) {
  const {
    scrollY
  } = useScroll();
  const [activeId, setActiveId] = useState(null);
  const positionsRef = useRef([]);
  const categories = useMemo(() => groupedFaqs.map(g => ({
    id: toId(g.category),
    label: g.category
  })), [groupedFaqs]);

  // 섹션 위치 계산
  const recalcPositions = () => {
    positionsRef.current = categories.map(({
      id
    }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const rect = el.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      return {
        id,
        top
      };
    }).filter(v => !!v).sort((a, b) => a.top - b.top);
  };
  useEffect(() => {
    // 최초/데이터 변경 시 포지션 갱신
    const t = setTimeout(recalcPositions, 50);
    const onResize = () => recalcPositions();
    window.addEventListener('resize', onResize);
    window.addEventListener('load', recalcPositions);

    // 이미지 로드 이후 반영
    const images = Array.from(document.images);
    const onImg = () => setTimeout(recalcPositions, 50);
    images.forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', onImg);
        img.addEventListener('error', onImg);
      }
    });
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', recalcPositions);
      images.forEach(img => {
        img.removeEventListener('load', onImg);
        img.removeEventListener('error', onImg);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories.map(c => c.id).join('|')]);

  // 스크롤Y 변경에 따른 활성 섹션 계산
  useEffect(() => {
    if (!positionsRef.current.length) return;
    const offset = 96; // 고정 헤더/내비 높이 보정
    const current = scrollY + offset;
    let currentId = positionsRef.current[0].id;
    for (const pos of positionsRef.current) {
      if (pos.top <= current) {
        currentId = pos.id;
      } else {
        break;
      }
    }
    setActiveId(currentId);
  }, [scrollY]);
  return <>
      <div className="px-marg py-gutter max-md:bg-system-gnbbg sticky top-[calc(3.6125rem-var(--spacing-gutter))] z-50 flex gap-4 select-none max-md:top-[var(--headerh)] max-md:pt-0">
        {categories.map(({
        id,
        label
      }) => <a key={`anchor-${id}`} href={`#${id}`} className={cx('h5 transition-opacity', activeId === id ? 'opacity-100' : 'opacity-30')}>
            {label}
          </a>)}
      </div>
      <div className="max-md:h-[calc(var(--headerh)-var(--spacing-gutter))]"></div>
      {groupedFaqs.map(({
      category,
      items
    }, i) => {
      const id = toId(category);
      return <Fragment key={`group-${id}-${i}`}>
            {items.map((item, j) => <GridLayout key={`${category}-grid-${id}-${i}-${j}`} id={j === 0 ? id : undefined} className="odd:bg-system-tilebg px-marg text-gray-40 items-start pt-3 pb-12 text-left whitespace-break-spaces max-md:gap-0.5">
                <GridItem cols={2} className="max-md:col-span-6">
                  <p className="bold text-green-50">{category}</p>
                </GridItem>
                <GridItem cols={10}>
                  <p>{item}</p>
                </GridItem>
              </GridLayout>)}
          </Fragment>;
    })}
    </>;
}